module.exports = __webpack_public_path__ + "img/1543830996.783613f8.jpg";